"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CatalogBasket = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_redux_1 = require("react-redux");
var react_i18next_1 = require("react-i18next");
var Basket_1 = require("../../../components/Basket/Basket");
require("./style.scss");
var classnames_1 = __importDefault(require("classnames"));
var CatalogBasket = function (props) {
    var _a;
    var t = (0, react_i18next_1.useTranslation)().t;
    var items = (0, react_redux_1.useSelector)(function (state) { return state.cart.items; });
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: (0, classnames_1.default)('catalog-basket', (_a = {}, _a[props.className || ''] = props.showBasket, _a)) }, { children: items.length === 0 ? ((0, jsx_runtime_1.jsxs)("div", __assign({ className: 'empty-basket' }, { children: [(0, jsx_runtime_1.jsx)("h3", __assign({ className: 'title' }, { children: t('Your cart is empty') })), (0, jsx_runtime_1.jsx)("div", { children: t('Looks like you haven’t added anything to your cart yet') })] }))) : ((0, jsx_runtime_1.jsx)(Basket_1.Basket, __assign({}, props))) })));
};
exports.CatalogBasket = CatalogBasket;
